export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ouvrir un litige"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Un modérateur rejoindra pour vous aider. Veuillez sélectionner une raison et joindre des preuves."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer au modérateur"])}
}